var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'burger',
    _vm.$store.state.isMenuOpen ? 'burger--close' : '' ]},[_c('span',{staticClass:"burger__line"}),_c('span',{staticClass:"burger__line"}),_c('span',{staticClass:"burger__line"}),_c('span',{staticClass:"burger__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }